<template>
  <v-data-table
    ref="items_list"
    :headers="headers"
    :items="items"
    :items-per-page="-1"
    hide-default-footer
  >
    <template v-slot:item.sales_number="{ item }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            :to="'/transactions/' + item.id"
            class="p-0"
            :color="$vuetify.theme.isDark ? 'white' : 'orange'"
            small
            text
            v-on="on"
            >{{ item.sales_number }}
            <sup v-if="item.pos_sale">
              <v-icon x-small>mdi-cart-outline</v-icon>
            </sup>
          </v-btn>
        </template>
        <span>View Details</span>
      </v-tooltip>
    </template>

    <template v-slot:item.amount_due="{ item }">
      {{ item.amount_due | toMoney | currency_symbol }}
    </template>

    <template v-slot:item.entry_date="{ item }">
      {{ item.entry_date | humanDate }}
    </template>

    <template v-slot:item.created_at="{ item }">
      {{ item.created_at | humanDateTime }}
    </template>
  </v-data-table>
</template>

<script>
import { CURRENCY } from "../data";

export default {
  name: "AssociatedSales",
  props: {
    items: {
      type: Array,
      required: true,
    },
    hasQuantity: {
      type: Array,
      default: () => false,
    },
  },
  data() {
    return {
      currencyList: CURRENCY,
      headers: [
        {
          text: "Sale #",
          align: "center",
          sortable: true,
          value: "sales_number",
        },
        {
          text: "Net Amount",
          value: "amount_due",
          align: "right",
        },
        {
          text: "Date",
          value: "entry_date",
          align: "center",
        },
        {
          ...(this.hasQuantity
            ? {
                text: "Quantity",
                value: "quantity",
                align: "center",
              }
            : {}),
        },
        {
          text: "Created At",
          value: "created_at",
        },
      ],
    };
  },
  methods: {
    fxCurrency(currency) {
      const fx = this.currencyList.find((c) => c.cc === currency);
      return fx ? fx.symbol : this.baseSymbol;
    },
  },
};
</script>
